export default __webpack_public_path__ + "static/media/04-entrada-premium.7659d224.png";